import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import type { PageCSSVars, PageDefinition } from '@wix/thunderbolt-becky-types'
import { getBackgroundMedia } from '../PageBackground/PageBackground.mapper'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'

// Remove Partial
export const css = withCompInfo<Partial<PageCSSVars>, PageDefinition>()(
	[
		'compId',
		'compDesign',
		'experiments',
		'styleProperties',
		'hasResponsiveLayout',
		'compProps',
		'isMobileView',
		'siteColors',
		'compData',
		'viewMode',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compId,
		compDesign,
		experiments,
		styleProperties,
		hasResponsiveLayout,
		compProps,
		isMobileView,
		siteColors,
		compData,
		viewMode,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		if (compData.isPopup) {
			if (hasResponsiveLayout) {
				return { width: '100%', height: 'auto' }
			}

			const backgroundMedia = getBackgroundMedia(compData, isMobileView)
			const fillLayersCss = getFillLayersCSSVars({
				animations,
				backgroundMedia,
				compId,
				compDesign,
				compProps,
				experiments,
				isMobileView,
				isNonAdaptiveMobile,
				siteColors,
				viewMode,
			})
			return {
				...fillLayersCss,
				width: 'auto',
			}
		}

		const pageMinHeightDefault = isMobileView ? 200 : 500
		const deviceCompProp = isMobileView ? compProps.mobile : compProps.desktop

		const minHeight = (deviceCompProp && deviceCompProp.minHeight) || pageMinHeightDefault
		const minHeightValue = typeof minHeight === 'number' ? `${minHeight}px` : minHeight

		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})

		const classicStyles = hasResponsiveLayout ? {} : { width: 'auto', 'min-height': minHeightValue }

		const fixChrome130Css = hasResponsiveLayout
			? {
				'justify-self': 'unset',
			}
			: {}

		return {
			...brightnessParams,
			...classicStyles,
			...fixChrome130Css,
		}
	}
)
